import { EventLog, EventLogType } from 'types/eventLog.ts'
import { GetMyEventsResponse, SelectEventsByEventLogType } from 'store/queries/bolt-api/contacts/types.ts'
import { memoize } from 'proxy-memoize'

/**
 * Selects events by their EventLogType from a list of events.
 * @param {SelectEventsByEventLogType} params
 * @returns {EventLog[]}
 */
const getEventsByEventLogType = ({ events, type }: SelectEventsByEventLogType): EventLog[] => {
  if (!events?.length) return []

  const eventsMap = new Map<EventLogType, GetMyEventsResponse['events']>()

  events.forEach((event) => {
    if (!eventsMap.has(event.type)) {
      eventsMap.set(event.type, [])
    }

    eventsMap.get(event.type)?.push(event)
  })

  return eventsMap.get(type) || []
}

/**
 * Memoized selector for the getEventsByEventLogType function
 * @type {(obj: SelectEventsByEventLogType) => EventLog[]}
 */
export const selectEventsByEventLogType = memoize<SelectEventsByEventLogType, EventLog[]>(getEventsByEventLogType)
